import React from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';

import { getRichTextOptions } from './helpers/getRichTextOptions';

interface IProps {
  blogPost: Document;
  className?: string;
}

export const BlogPostContent = ({ blogPost, className = '' }: IProps) => {
  const richTextOptions = getRichTextOptions();
  return (
    <div
      className={`prose prose-fishbrain flex flex-col prose-headings:mt-4 prose-headings:sm:mt-8 ${className}`}
    >
      {documentToReactComponents(blogPost, richTextOptions)}
    </div>
  );
};
